// extracted by mini-css-extract-plugin
export default {"allProjects":"QuotationsList_allProjects__Yl9JU","emptyState":"QuotationsList_emptyState__lHeZC","emptyStateText":"QuotationsList_emptyStateText__Eg0yb"};